import * as React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import "./Registracia.scss";

// prop types
import oAuthUserPropTypes from "../../propTypes/oAuthUserPropTypes";

// components
import withRouter from "../../coraWebComponents/utils/withRouter";
import GoogleButton from "../../coraWebComponents/buttons/GoogleButton";
import LoadingPanel from "../../coraWebComponents/LoadingPanel";
import Registration from "../../coraWebComponents/views/registration/Registration";
import RegistraciaNextStep from "./RegistraciaNextStep";

// routes
import Routes from "../../constants/Routes";

// actions
import * as oAuthActions from "../../actions/oAuthActions";
import * as verifyActions from "../../actions/verifyActions";

// const googleRedirectURI = `http://localhost:3000?provider=1`;
const googleRedirectURI = `${window.config.redirectURI}?provider=1`;

class Registracia extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      password: "",
      RCTOKEN: "",
      ErrText: "",
      titles: {
        email: `Vložte  Váš  existujúci a platný email. Bude Vašim prihlasovacím menom.`,
        password: `Vložte vaše heslo. Musí obsahovať aspoň 8 znakov, 
          z ktorých aspoň jeden musí byť číslica a aspoň jeden musí byť nealfanumerický znak.`,
        verifyPassword: `Zopakujte opätovne heslo. Musí byť rovnaké ako v predchádzajúcom riadku.`,
      },
      showRegistrationForm: true,
    };
  }

  verifyEmailAndPass = async ({ email, password }) => {
    await this.props.verifyEmailAndPass({ email, password });

    if (this.props.verifyMessage === "OK") {
      this.setState((state) => ({
        ...state,
        email,
        password,
        showRegistrationForm: false,
      }));
    }
  };

  handleOnNext = async (registrationState) => {
    const { email, password } = registrationState;
    await this.verifyEmailAndPass({ email, password });
  };
  handleOnBack = () => {
    this.setState((state) => ({ ...state, showRegistrationForm: true }));
    this.props.navigate(`${Routes.REGISTRACIA}`, { replace: true });
  };
  handleOnRegisterOAuth = async (code, provider) => {
    const { registerOAuth, navigate } = this.props;
    await registerOAuth(code, googleRedirectURI, provider);

    const { oAuthUser } = this.props;
    if (oAuthUser?.email) {
      this.setState((state) => ({
        ...state,
        email: oAuthUser.email,
        password: "",
        showRegistrationForm: false,
      }));
    }

    navigate(Routes.REGISTRACIA, { replace: true });
  };

  render() {
    const { isLoading } = this.props;
    const { titles, email, password, showRegistrationForm } = this.state;

    if (showRegistrationForm && email !== "") this.setState({ email: "" });
    return (
      <>
        {showRegistrationForm ? (
          <Registration
            isLoading={isLoading}
            header={<h1>Registrácia</h1>}
            onSubmit={this.handleOnNext}
            showUsernameInput={false}
            emailValue={email}
            oAuthRegister={this.handleOnRegisterOAuth}
            titles={titles}
            hide={{ username: true }}
            registerButtonLabel="Pokračovať"
          >
            {false && <div className="k-form-field">
              <div className="line">
                <span className="service-label">alebo</span>
              </div>
              <div className="row m-0">
                <GoogleButton
                  redirectURI={googleRedirectURI}
                  state="createUser"
                  primary={false}
                />
              </div>
            </div>}

            <div className="k-form-field">
              <div className="footerContainerRegister">
                <a className="login" href={`#${Routes.LOGIN}`}>
                  Prihlásenie
                </a>
              </div>
            </div>
          </Registration>
        ) : (
          <RegistraciaNextStep
            email={email}
            password={password}
            onBack={this.handleOnBack}
          />
        )}
        <LoadingPanel isLoading={isLoading} />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isLoading:
      state.oAuthUser.isLoading ||
      state.user.isLoading ||
      state.verifications.isLoading,
    oAuthUser: state.oAuthUser.data,
    verifyMessage: state.verifications.message,
  };
};

const mapDispatchToProps = (dispatch) => ({
  registerOAuth: (code, redirect_uri, provider) =>
    dispatch(oAuthActions.registerOAuth(code, redirect_uri, provider)),
  verifyEmailAndPass: (data) => dispatch(verifyActions.emailAndPass(data)),
});

Registracia.propTypes = {
  isLoading: PropTypes.bool,
  oAuthUser: oAuthUserPropTypes.oAuthUser,
  registerOAuth: PropTypes.func,
  verifyEmailAndPass: PropTypes.func,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Registracia)
);
